//@flow
import React from 'react'
import { Waypoint } from 'react-waypoint'
import Lottie from 'react-lottie'
import trainPassing from './images/train-passing.json'
import trainPassingDark from './images/train-passing-dark.json'
import iconDelay from './images/delay.svg'
import iconDuration from './images/duration.svg'
import './styles.scss'

const animationLightOptions = {
  loop: false,
  autoplay: false,
  animationData: trainPassing,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}
const animationDarkOptions = {
  loop: false,
  autoplay: false,
  animationData: trainPassingDark,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export class Route extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      play: false
    }
    this.updateSizes = this.updateSizes.bind(this)
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    return <div className='route'>
        <h3>{this.props.pretitle}</h3>
        <h2>{this.props.start} ⇔ {this.props.end}</h2>
        <div className='stats'>
          <div className={this.state.play ? 'ontime show' : 'ontime'}>
            <div className={this.props.color === 'red' ? 'percentage red' : this.props.color === 'green' ? 'percentage green' : 'percentage'}>
              {this.props.percentage} à l'heure
            </div>
            <div className='animation'>
              {this.props.colorMode === 'light' && (
                <Lottie
                  isStopped={!this.state.play}
                  options={animationLightOptions}
                  /*
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: () => this.setState({ play: false })
                    }
                  ]}
                  */
                />
              )}
              {this.props.colorMode === 'dark' && (
                <Lottie
                  isStopped={!this.state.play}
                  options={animationDarkOptions}
                  /*
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: () => this.setState({ play: false })
                    }
                  ]}
                  */
                />
              )}
            </div>
          </div>
          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              this.setState({ play: true })
            }}
            onLeave={event => {
              this.setState({ play: false })
            }}
          >
            <div className='details'>
              <div className='duration'>
                  <div className='value'>
                    <img className='icon' src={iconDuration} alt='icon' />
                    {this.props.duration}
                  </div>
                  <div className='label'>Durée du trajet</div>
              </div>
              <div className='delay'>
                <div className='value'>
                  <img className='icon' src={iconDelay} alt='icon' />
                  {this.props.delaytime}
                </div>
                <div className='label'>Retard à l'arrivée</div>
              </div>
            </div>
          </Waypoint>
        </div>

    </div>
  }
}



             